/**
 * Returns if the value is a number or not.
 * @param val Any value.
 */
const isFunction = (val): boolean => {
  return "function" === typeof val;
};

export default isFunction;
